import { Stack } from "react-bootstrap";
import OutputAreaDropdown from "./OutputAreaDropdown";
import CensusYearDropdown from "./CensusYearDropdown";
import CategoryDropdown from "./CategoryDropdown";
import ColumnDropdown from "./ColumnDropdown";
import ViewToolsContainer from "../../../../boundarySelection/ViewTools/ViewToolsContainer";
import { CensusCategory } from "../../../../../types/Census/CensusCategory";

interface CensusViewToolsProps {
  categories: CensusCategory[];
  categoriesLoading: boolean;
  showValidationError: boolean;
}

const CensusViewTools = ({
  categories,
  categoriesLoading,
  showValidationError,
}: CensusViewToolsProps) => {
  return (
    <ViewToolsContainer>
      <Stack gap={2}>
        <CensusYearDropdown />
        <OutputAreaDropdown />
        <CategoryDropdown
          loading={categoriesLoading}
          categories={categories}
          showValidationError={showValidationError}
        />
        <ColumnDropdown
          loading={categoriesLoading}
          categories={categories}
          showValidationError={showValidationError}
        />
      </Stack>
    </ViewToolsContainer>
  );
};

export default CensusViewTools;
